import { Model } from "./model";

export class Retailer extends Model {
    id: number;
    country_id: number;
    country_name: string;
    name: string;
    code: string;
    retailer_logo_url?: string;
    logo?: string;
    created: string;
    modified?: string;
}



// WEBPACK FOOTER //
// ./src/models/retailer.model.ts